import ContentLoader from "react-content-loader"

type LoadingType = 'line' | 'circle' | 'cube';

const Loading: React.FC<{
    count?: number,
    width?: string | number,
    type?: LoadingType
}> = ({
    count = 4,
    width = "100%",
    type = 'line',
    ...props
}) => {
        const renderLineLoader = () => {
            return Array.from({ length: count }).map((_, index) => (
                <rect
                    key={index}
                    x="0"
                    y={index * 30}
                    rx="8"
                    ry="8"
                    width={index === count - 1 && count > 1 ? "50%" : "100%"}
                    height="15"
                />
            ))
        }

        const renderCircleLoader = () => {
            const radius = 40
            return (
                <circle
                    cx={radius}
                    cy={radius}
                    r={radius}
                />
            )
        }

        const renderCubeLoader = () => {
            const size = 100
            return (
                <rect
                    x="0"
                    y="0"
                    rx="8"
                    ry="8"
                    width={size}
                    height={size}
                />
            )
        }

        const getLoader = () => {
            switch (type) {
                case 'circle':
                    return renderCircleLoader()
                case 'cube':
                    return renderCubeLoader()
                case 'line':
                default:
                    return renderLineLoader()
            }
        }

        const getHeight = () => {
            switch (type) {
                case 'circle':
                    return 80
                case 'cube':
                    return 100
                case 'line':
                default:
                    return (count * 30) - 15
            }
        }

        return (
            <ContentLoader
                speed={2}
                width={width}
                height={getHeight()}
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                {...props}
            >
                {getLoader()}
            </ContentLoader>
        )
    }

export default Loading;
